import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Activity, ArrowLeft, Loader2, Mail, CircleCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authAPI.forgotPassword(email);
      setSent(true);
      toast.success(res.data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Anfrage fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-12" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-8 neon-glow">
          <Activity className="w-6 h-6 text-primary" />
        </div>

        {sent ? (
          <div className="space-y-4" data-testid="forgot-password-sent">
            <CircleCheck className="w-10 h-10 text-emerald-400" />
            <h2 className="font-heading font-bold text-3xl">E-Mail unterwegs</h2>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Falls ein Konto mit <span className="text-foreground">{email}</span> existiert, haben wir dir
              einen Link zum Zurücksetzen geschickt. Der Link ist 60 Minuten gültig und nur einmal verwendbar.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 text-primary hover:underline text-sm" data-testid="back-to-login-link">
              <ArrowLeft className="w-4 h-4" /> Zurück zur Anmeldung
            </Link>
          </div>
        ) : (
          <>
            <div className="mb-8">
              <h2 className="font-heading font-bold text-3xl mb-2">Passwort vergessen</h2>
              <p className="text-muted-foreground text-sm">
                Gib deine E-Mail-Adresse ein – wir senden dir einen Link zum Zurücksetzen.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
              <div className="space-y-2">
                <Label htmlFor="email">E-Mail</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="name@firma.de"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-12 bg-background"
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-full h-12 font-bold tracking-wider uppercase bg-primary text-primary-foreground hover:bg-primary/90"
                data-testid="forgot-submit-btn"
              >
                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Mail className="w-4 h-4 mr-2" />}
                Link senden
              </Button>
            </form>
            <p className="text-center text-sm text-muted-foreground mt-8">
              <Link to="/login" className="text-primary hover:underline font-medium" data-testid="back-to-login-link">
                Zurück zur Anmeldung
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
